import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_WEIGHT_UNITIES_APP_ROOT = `${BASE_ADMIN_V2_PATH}/weight-unities`;

export const ADMIN_WEIGHT_UNITIES_APP_PATHS = {
  WEIGHT_UNITIES_LIST: `${ADMIN_WEIGHT_UNITIES_APP_ROOT}`,
};
